export enum PriceDisplayEnum {
  PRICE = 'price-excludes-shipping',
  PRICE_INCLUDES_SHIPPING = 'price_includes_shipping',
}

export type PriceDisplay =
  | PriceDisplayEnum.PRICE
  | PriceDisplayEnum.PRICE_INCLUDES_SHIPPING;

export enum SortOptionEnum {
  PRICE = 'price',
  PRICEANDSTOCKSTATUS = 'price_in_stock',
  RECOMMENDED = 'recommended',
  FEATURED = 'featured',
}

export type SortOption =
  | SortOptionEnum.PRICE
  | SortOptionEnum.RECOMMENDED
  | SortOptionEnum.PRICEANDSTOCKSTATUS
  | SortOptionEnum.FEATURED;
